var map = {
	"./": 18063,
	"./Stact": 5944,
	"./Stact.jsx": 5944,
	"./Stact.template": 26227,
	"./Stact.template.jsx": 26227,
	"./bx-logo-dark.png": 60583,
	"./bx-logo-light.png": 79079,
	"./data/404": 13330,
	"./data/404.json": 13330,
	"./data/about": 43939,
	"./data/about.json": 43939,
	"./data/contact": 92558,
	"./data/contact.json": 92558,
	"./data/cookie": 50112,
	"./data/cookie.json": 50112,
	"./data/faq": 88782,
	"./data/faq.json": 88782,
	"./data/home": 91577,
	"./data/home.json": 91577,
	"./data/playground": 87663,
	"./data/playground.json": 87663,
	"./data/privacy": 24518,
	"./data/privacy.json": 24518,
	"./data/shared": 94855,
	"./data/shared.json": 94855,
	"./data/terms": 269,
	"./data/terms.json": 269,
	"./index": 18063,
	"./index.js": 18063,
	"./index.scss": 13782,
	"./logo.svg": 69445,
	"./logo_dark.svg": 47780,
	"./main/components/blogCards": 1863,
	"./main/components/blogCards/": 1863,
	"./main/components/blogCards/index": 1863,
	"./main/components/blogCards/index.jsx": 1863,
	"./main/components/blogCards/style.scss": 86062,
	"./main/components/brandSection": 5966,
	"./main/components/brandSection/": 5966,
	"./main/components/brandSection/index": 5966,
	"./main/components/brandSection/index.jsx": 5966,
	"./main/components/brandSection/style.scss": 41831,
	"./main/components/contactSection": 7763,
	"./main/components/contactSection/": 7763,
	"./main/components/contactSection/assets/bg_1.svg": 4210,
	"./main/components/contactSection/assets/bg_2.svg": 9249,
	"./main/components/contactSection/assets/scribble.svg": 84175,
	"./main/components/contactSection/index": 7763,
	"./main/components/contactSection/index.jsx": 7763,
	"./main/components/contactSection/style.scss": 42916,
	"./main/components/featureCards": 50577,
	"./main/components/featureCards/": 50577,
	"./main/components/featureCards/index": 50577,
	"./main/components/featureCards/index.jsx": 50577,
	"./main/components/featureCards/style.scss": 40930,
	"./main/components/footer": 30827,
	"./main/components/footer/": 30827,
	"./main/components/footer/index": 30827,
	"./main/components/footer/index.jsx": 30827,
	"./main/components/footer/style.scss": 64688,
	"./main/components/navbar": 15160,
	"./main/components/navbar/": 15160,
	"./main/components/navbar/index": 15160,
	"./main/components/navbar/index.jsx": 15160,
	"./main/components/navbar/style.scss": 91065,
	"./main/components/pricingCard": 8366,
	"./main/components/pricingCard/": 8366,
	"./main/components/pricingCard/index": 8366,
	"./main/components/pricingCard/index.jsx": 8366,
	"./main/components/pricingCard/style.scss": 93129,
	"./main/components/projectCards": 74054,
	"./main/components/projectCards/": 74054,
	"./main/components/projectCards/index": 74054,
	"./main/components/projectCards/index.jsx": 74054,
	"./main/components/projectCards/style.scss": 89043,
	"./main/components/serviceCards": 5900,
	"./main/components/serviceCards/": 5900,
	"./main/components/serviceCards/index": 5900,
	"./main/components/serviceCards/index.jsx": 5900,
	"./main/components/serviceCards/style.scss": 80253,
	"./main/components/testimonialCards": 41092,
	"./main/components/testimonialCards/": 41092,
	"./main/components/testimonialCards/index": 41092,
	"./main/components/testimonialCards/index.jsx": 41092,
	"./main/components/testimonialCards/style.scss": 13597,
	"./main/pages/404": 40697,
	"./main/pages/404/": 40697,
	"./main/pages/404/assets/bg_1.svg": 37465,
	"./main/pages/404/assets/bg_2.svg": 46090,
	"./main/pages/404/index": 40697,
	"./main/pages/404/index.jsx": 40697,
	"./main/pages/404/style.scss": 52945,
	"./main/pages/FAQs": 55159,
	"./main/pages/FAQs/": 55159,
	"./main/pages/FAQs/index": 55159,
	"./main/pages/FAQs/index.jsx": 55159,
	"./main/pages/FAQs/style.scss": 35314,
	"./main/pages/about": 45771,
	"./main/pages/about/": 45771,
	"./main/pages/about/assets/about-hero-image.png": 38863,
	"./main/pages/about/assets/ecommerce.png": 30271,
	"./main/pages/about/assets/education.png": 4545,
	"./main/pages/about/assets/fintech.png": 18456,
	"./main/pages/about/assets/healthcare.png": 81830,
	"./main/pages/about/assets/local-business.png": 44683,
	"./main/pages/about/assets/messaging.png": 60779,
	"./main/pages/about/assets/publishing.png": 69508,
	"./main/pages/about/assets/real-estate.png": 97302,
	"./main/pages/about/assets/team1.jpg": 19819,
	"./main/pages/about/assets/team2.jpg": 35164,
	"./main/pages/about/assets/team3.jpg": 22041,
	"./main/pages/about/assets/team4.jpg": 85322,
	"./main/pages/about/assets/video_thumb.jpg": 49671,
	"./main/pages/about/index": 45771,
	"./main/pages/about/index.jsx": 45771,
	"./main/pages/about/style.scss": 13256,
	"./main/pages/contact": 22791,
	"./main/pages/contact/": 22791,
	"./main/pages/contact/assets/contact_ico1.svg": 25139,
	"./main/pages/contact/assets/contact_ico2.svg": 54240,
	"./main/pages/contact/assets/contact_ico3.svg": 689,
	"./main/pages/contact/index": 22791,
	"./main/pages/contact/index.jsx": 22791,
	"./main/pages/contact/style.scss": 28909,
	"./main/pages/cookie": 51738,
	"./main/pages/cookie/": 51738,
	"./main/pages/cookie/assets/cookie-policy.png": 25877,
	"./main/pages/cookie/index": 51738,
	"./main/pages/cookie/index.jsx": 51738,
	"./main/pages/cookie/style.scss": 71605,
	"./main/pages/home": 44237,
	"./main/pages/home/": 44237,
	"./main/pages/home/assets/3rd-party-customization.svg": 30031,
	"./main/pages/home/assets/about1-x.png": 16334,
	"./main/pages/home/assets/about1.png": 74717,
	"./main/pages/home/assets/about2-x.png": 68989,
	"./main/pages/home/assets/about2.png": 33478,
	"./main/pages/home/assets/authenticity.png": 22862,
	"./main/pages/home/assets/aws.png": 36438,
	"./main/pages/home/assets/brand1.svg": 88587,
	"./main/pages/home/assets/brand2.svg": 49752,
	"./main/pages/home/assets/brand3.svg": 84617,
	"./main/pages/home/assets/brand4.svg": 82022,
	"./main/pages/home/assets/brand5.svg": 69559,
	"./main/pages/home/assets/cloud-and-devops-consulting.svg": 77525,
	"./main/pages/home/assets/culture_1.png": 11795,
	"./main/pages/home/assets/culture_2.png": 16184,
	"./main/pages/home/assets/culture_3.png": 37313,
	"./main/pages/home/assets/database-development-services.svg": 53105,
	"./main/pages/home/assets/docker.png": 83701,
	"./main/pages/home/assets/embedded-software.svg": 41710,
	"./main/pages/home/assets/git.png": 32401,
	"./main/pages/home/assets/hero_image-x.png": 13812,
	"./main/pages/home/assets/hero_image.png": 23811,
	"./main/pages/home/assets/innovation.png": 11580,
	"./main/pages/home/assets/integrity.png": 55380,
	"./main/pages/home/assets/it-support-services.svg": 89235,
	"./main/pages/home/assets/mobile-application-development.svg": 12492,
	"./main/pages/home/assets/mongodb.png": 26003,
	"./main/pages/home/assets/mysql.png": 54479,
	"./main/pages/home/assets/nestjs.png": 2974,
	"./main/pages/home/assets/nodejs.png": 67920,
	"./main/pages/home/assets/php.png": 13453,
	"./main/pages/home/assets/postgresql.png": 84511,
	"./main/pages/home/assets/quality-assurance.svg": 65818,
	"./main/pages/home/assets/reactjs.png": 24753,
	"./main/pages/home/assets/requirements-engineering.svg": 94305,
	"./main/pages/home/assets/review_brand1.svg": 64634,
	"./main/pages/home/assets/review_brand2.svg": 32745,
	"./main/pages/home/assets/review_brand3.svg": 28504,
	"./main/pages/home/assets/review_user1.svg": 69144,
	"./main/pages/home/assets/review_user2.svg": 27211,
	"./main/pages/home/assets/review_user3.svg": 33338,
	"./main/pages/home/assets/service_ico1.svg": 43311,
	"./main/pages/home/assets/service_ico2.svg": 40988,
	"./main/pages/home/assets/service_ico3.svg": 69533,
	"./main/pages/home/assets/service_ico4.svg": 35602,
	"./main/pages/home/assets/solutions-architecture.svg": 89671,
	"./main/pages/home/assets/startup-team-bootstrapping.svg": 21165,
	"./main/pages/home/assets/ui-ux-designing.svg": 36124,
	"./main/pages/home/assets/web-development.svg": 51539,
	"./main/pages/home/index": 44237,
	"./main/pages/home/index.jsx": 44237,
	"./main/pages/home/style.scss": 34544,
	"./main/pages/playground": 63987,
	"./main/pages/playground/": 63987,
	"./main/pages/playground/assets/project1.png": 11575,
	"./main/pages/playground/assets/project2.png": 22844,
	"./main/pages/playground/assets/project3.png": 40357,
	"./main/pages/playground/assets/project4.png": 55690,
	"./main/pages/playground/assets/project5.png": 22803,
	"./main/pages/playground/assets/project6.png": 31960,
	"./main/pages/playground/assets/project7.png": 4673,
	"./main/pages/playground/assets/project8.png": 64870,
	"./main/pages/playground/assets/project9.png": 49967,
	"./main/pages/playground/index": 63987,
	"./main/pages/playground/index.jsx": 63987,
	"./main/pages/playground/style.scss": 72214,
	"./main/pages/privacy": 4340,
	"./main/pages/privacy/": 4340,
	"./main/pages/privacy/assets/privacy-policy.png": 86615,
	"./main/pages/privacy/index": 4340,
	"./main/pages/privacy/index.jsx": 4340,
	"./main/pages/privacy/style.scss": 91661,
	"./main/pages/terms": 26537,
	"./main/pages/terms/": 26537,
	"./main/pages/terms/assets/article_cover.jpg": 65419,
	"./main/pages/terms/index": 26537,
	"./main/pages/terms/index.jsx": 26537,
	"./main/pages/terms/style.scss": 80794,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./template/components/blogCards": 98868,
	"./template/components/blogCards/": 98868,
	"./template/components/blogCards/index": 98868,
	"./template/components/blogCards/index.jsx": 98868,
	"./template/components/blogCards/style.scss": 19879,
	"./template/components/brandSection": 44959,
	"./template/components/brandSection/": 44959,
	"./template/components/brandSection/index": 44959,
	"./template/components/brandSection/index.jsx": 44959,
	"./template/components/brandSection/style.scss": 79236,
	"./template/components/contactSection": 28224,
	"./template/components/contactSection/": 28224,
	"./template/components/contactSection/assets/bg_1.svg": 84079,
	"./template/components/contactSection/assets/bg_2.svg": 5052,
	"./template/components/contactSection/assets/scribble.svg": 38294,
	"./template/components/contactSection/index": 28224,
	"./template/components/contactSection/index.jsx": 28224,
	"./template/components/contactSection/style.scss": 23799,
	"./template/components/featureCards": 79728,
	"./template/components/featureCards/": 79728,
	"./template/components/featureCards/index": 79728,
	"./template/components/featureCards/index.jsx": 79728,
	"./template/components/featureCards/style.scss": 74605,
	"./template/components/footer": 27160,
	"./template/components/footer/": 27160,
	"./template/components/footer/index": 27160,
	"./template/components/footer/index.jsx": 27160,
	"./template/components/footer/style.scss": 94775,
	"./template/components/navbar": 94930,
	"./template/components/navbar/": 94930,
	"./template/components/navbar/index": 94930,
	"./template/components/navbar/index.jsx": 94930,
	"./template/components/navbar/style.scss": 53094,
	"./template/components/pricingCard": 89837,
	"./template/components/pricingCard/": 89837,
	"./template/components/pricingCard/index": 89837,
	"./template/components/pricingCard/index.jsx": 89837,
	"./template/components/pricingCard/style.scss": 81604,
	"./template/components/projectCards": 35315,
	"./template/components/projectCards/": 35315,
	"./template/components/projectCards/index": 35315,
	"./template/components/projectCards/index.jsx": 35315,
	"./template/components/projectCards/style.scss": 23188,
	"./template/components/serviceCards": 57841,
	"./template/components/serviceCards/": 57841,
	"./template/components/serviceCards/index": 57841,
	"./template/components/serviceCards/index.jsx": 57841,
	"./template/components/serviceCards/style.scss": 7390,
	"./template/components/testimonialCards": 75413,
	"./template/components/testimonialCards/": 75413,
	"./template/components/testimonialCards/index": 75413,
	"./template/components/testimonialCards/index.jsx": 75413,
	"./template/components/testimonialCards/style.scss": 84506,
	"./template/pages/404": 31058,
	"./template/pages/404/": 31058,
	"./template/pages/404/assets/bg_1.svg": 18744,
	"./template/pages/404/assets/bg_2.svg": 73931,
	"./template/pages/404/index": 31058,
	"./template/pages/404/index.jsx": 31058,
	"./template/pages/404/style.scss": 78802,
	"./template/pages/FAQs": 83784,
	"./template/pages/FAQs/": 83784,
	"./template/pages/FAQs/index": 83784,
	"./template/pages/FAQs/index.jsx": 83784,
	"./template/pages/FAQs/style.scss": 1735,
	"./template/pages/about": 10166,
	"./template/pages/about/": 10166,
	"./template/pages/about/assets/team1.jpg": 13280,
	"./template/pages/about/assets/team2.jpg": 10543,
	"./template/pages/about/assets/team3.jpg": 54514,
	"./template/pages/about/assets/team4.jpg": 80001,
	"./template/pages/about/assets/video_thumb.jpg": 19928,
	"./template/pages/about/index": 10166,
	"./template/pages/about/index.jsx": 10166,
	"./template/pages/about/style.scss": 87767,
	"./template/pages/appLanding": 63625,
	"./template/pages/appLanding/": 63625,
	"./template/pages/appLanding/assets/appstore_badge.svg": 41571,
	"./template/pages/appLanding/assets/end_banner.png": 89201,
	"./template/pages/appLanding/assets/feature_ico1.svg": 75474,
	"./template/pages/appLanding/assets/feature_ico2.svg": 68609,
	"./template/pages/appLanding/assets/feature_ico3.svg": 33072,
	"./template/pages/appLanding/assets/hero_image.png": 32863,
	"./template/pages/appLanding/assets/playstore_badge.svg": 83688,
	"./template/pages/appLanding/assets/review_brand1.svg": 15442,
	"./template/pages/appLanding/assets/review_brand2.svg": 8577,
	"./template/pages/appLanding/assets/review_brand3.svg": 73040,
	"./template/pages/appLanding/assets/review_user1.svg": 29872,
	"./template/pages/appLanding/assets/review_user2.svg": 86915,
	"./template/pages/appLanding/assets/review_user3.svg": 72274,
	"./template/pages/appLanding/assets/showcase1.png": 36553,
	"./template/pages/appLanding/assets/showcase2.png": 5586,
	"./template/pages/appLanding/assets/stats_icon1.svg": 69041,
	"./template/pages/appLanding/assets/stats_icon2.svg": 48674,
	"./template/pages/appLanding/assets/stats_icon3.svg": 53843,
	"./template/pages/appLanding/index": 63625,
	"./template/pages/appLanding/index.jsx": 63625,
	"./template/pages/appLanding/style.scss": 5544,
	"./template/pages/blog": 19795,
	"./template/pages/blog/": 19795,
	"./template/pages/blog/assets/blog_thumb1.jpg": 73037,
	"./template/pages/blog/assets/blog_thumb2.jpg": 10754,
	"./template/pages/blog/assets/blog_thumb3.jpg": 18815,
	"./template/pages/blog/assets/blog_thumb4.jpg": 51028,
	"./template/pages/blog/assets/blog_thumb5.jpg": 65361,
	"./template/pages/blog/assets/blog_thumb6.jpg": 37606,
	"./template/pages/blog/assets/blog_thumb7.jpg": 97091,
	"./template/pages/blog/assets/blog_thumb8.jpg": 12632,
	"./template/pages/blog/assets/blog_thumb9.jpg": 20501,
	"./template/pages/blog/index": 19795,
	"./template/pages/blog/index.jsx": 19795,
	"./template/pages/blog/style.scss": 36886,
	"./template/pages/blogArticle": 51223,
	"./template/pages/blogArticle/": 51223,
	"./template/pages/blogArticle/assets/article_cover.jpg": 44949,
	"./template/pages/blogArticle/index": 51223,
	"./template/pages/blogArticle/index.jsx": 51223,
	"./template/pages/blogArticle/style.scss": 39976,
	"./template/pages/consulting": 69643,
	"./template/pages/consulting/": 69643,
	"./template/pages/consulting/assets/about1.png": 97823,
	"./template/pages/consulting/assets/about2.png": 67908,
	"./template/pages/consulting/assets/brand1.svg": 39721,
	"./template/pages/consulting/assets/brand2.svg": 94906,
	"./template/pages/consulting/assets/brand3.svg": 88779,
	"./template/pages/consulting/assets/brand4.svg": 21188,
	"./template/pages/consulting/assets/brand5.svg": 2085,
	"./template/pages/consulting/assets/culture_1.png": 20557,
	"./template/pages/consulting/assets/culture_2.png": 6582,
	"./template/pages/consulting/assets/culture_3.png": 3519,
	"./template/pages/consulting/assets/hero_image.png": 61477,
	"./template/pages/consulting/assets/review_brand1.svg": 28956,
	"./template/pages/consulting/assets/review_brand2.svg": 31279,
	"./template/pages/consulting/assets/review_brand3.svg": 11230,
	"./template/pages/consulting/assets/review_user1.svg": 71082,
	"./template/pages/consulting/assets/review_user2.svg": 97081,
	"./template/pages/consulting/assets/review_user3.svg": 15336,
	"./template/pages/consulting/assets/service_ico1.svg": 22869,
	"./template/pages/consulting/assets/service_ico2.svg": 81622,
	"./template/pages/consulting/assets/service_ico3.svg": 68743,
	"./template/pages/consulting/assets/service_ico4.svg": 48936,
	"./template/pages/consulting/index": 69643,
	"./template/pages/consulting/index.jsx": 69643,
	"./template/pages/consulting/style.scss": 150,
	"./template/pages/contact": 40261,
	"./template/pages/contact/": 40261,
	"./template/pages/contact/assets/contact_ico1.svg": 55442,
	"./template/pages/contact/assets/contact_ico2.svg": 48577,
	"./template/pages/contact/assets/contact_ico3.svg": 13040,
	"./template/pages/contact/index": 40261,
	"./template/pages/contact/index.jsx": 40261,
	"./template/pages/contact/style.scss": 81150,
	"./template/pages/home": 44719,
	"./template/pages/home/": 44719,
	"./template/pages/home/assets/404.png": 940,
	"./template/pages/home/assets/FAQs.png": 54317,
	"./template/pages/home/assets/about.png": 75407,
	"./template/pages/home/assets/app_landing.png": 72049,
	"./template/pages/home/assets/bg_1.svg": 7541,
	"./template/pages/home/assets/bg_2.svg": 49942,
	"./template/pages/home/assets/blog.png": 14582,
	"./template/pages/home/assets/blog_article.png": 41189,
	"./template/pages/home/assets/coming_soon.png": 59433,
	"./template/pages/home/assets/consulting.png": 49994,
	"./template/pages/home/assets/contact.png": 23952,
	"./template/pages/home/assets/feature_1.svg": 60410,
	"./template/pages/home/assets/feature_2.svg": 75497,
	"./template/pages/home/assets/feature_3.svg": 40632,
	"./template/pages/home/assets/feature_4.svg": 60439,
	"./template/pages/home/assets/feature_5.svg": 72902,
	"./template/pages/home/assets/feature_6.svg": 72037,
	"./template/pages/home/assets/landing1.png": 14852,
	"./template/pages/home/assets/landing2.png": 68063,
	"./template/pages/home/assets/landing3.png": 54774,
	"./template/pages/home/assets/personal_portfolio.png": 39931,
	"./template/pages/home/assets/pricing.png": 24946,
	"./template/pages/home/assets/project_detail.png": 17259,
	"./template/pages/home/assets/projects.png": 25556,
	"./template/pages/home/assets/saas_landing.png": 99518,
	"./template/pages/home/assets/services.png": 32162,
	"./template/pages/home/index": 44719,
	"./template/pages/home/index.jsx": 44719,
	"./template/pages/home/style.scss": 94997,
	"./template/pages/landing1": 22857,
	"./template/pages/landing1/": 22857,
	"./template/pages/landing1/assets/about.png": 3746,
	"./template/pages/landing1/assets/blog_thumb1.jpg": 29351,
	"./template/pages/landing1/assets/blog_thumb2.jpg": 91896,
	"./template/pages/landing1/assets/blog_thumb3.jpg": 99765,
	"./template/pages/landing1/assets/brand1.svg": 16335,
	"./template/pages/landing1/assets/brand2.svg": 37308,
	"./template/pages/landing1/assets/brand3.svg": 65853,
	"./template/pages/landing1/assets/brand4.svg": 31922,
	"./template/pages/landing1/assets/brand5.svg": 64963,
	"./template/pages/landing1/assets/hero_image.png": 40063,
	"./template/pages/landing1/assets/hero_image.svg": 85621,
	"./template/pages/landing1/assets/service_ico1.svg": 51979,
	"./template/pages/landing1/assets/service_ico2.svg": 1240,
	"./template/pages/landing1/assets/service_ico3.svg": 5481,
	"./template/pages/landing1/assets/service_ico4.svg": 76038,
	"./template/pages/landing1/index": 22857,
	"./template/pages/landing1/index.jsx": 22857,
	"./template/pages/landing1/style.scss": 77228,
	"./template/pages/landing2": 95770,
	"./template/pages/landing2/": 95770,
	"./template/pages/landing2/assets/brand1.svg": 92316,
	"./template/pages/landing2/assets/brand2.svg": 71343,
	"./template/pages/landing2/assets/brand3.svg": 8766,
	"./template/pages/landing2/assets/brand4.svg": 17697,
	"./template/pages/landing2/assets/brand5.svg": 5456,
	"./template/pages/landing2/assets/hero_image.png": 88244,
	"./template/pages/landing2/assets/info.png": 17102,
	"./template/pages/landing2/assets/project1.png": 80970,
	"./template/pages/landing2/assets/project2.png": 29953,
	"./template/pages/landing2/assets/project3.png": 45336,
	"./template/pages/landing2/assets/review_brand1.svg": 89251,
	"./template/pages/landing2/assets/review_brand2.svg": 32208,
	"./template/pages/landing2/assets/review_brand3.svg": 67745,
	"./template/pages/landing2/assets/review_user1.svg": 57535,
	"./template/pages/landing2/assets/review_user2.svg": 78508,
	"./template/pages/landing2/assets/review_user3.svg": 77453,
	"./template/pages/landing2/assets/service_ico1.svg": 48464,
	"./template/pages/landing2/assets/service_ico2.svg": 14563,
	"./template/pages/landing2/assets/service_ico3.svg": 65170,
	"./template/pages/landing2/assets/service_ico4.svg": 15453,
	"./template/pages/landing2/assets/video_thumb.jpg": 95772,
	"./template/pages/landing2/index": 95770,
	"./template/pages/landing2/index.jsx": 95770,
	"./template/pages/landing2/style.scss": 69141,
	"./template/pages/landing3": 8943,
	"./template/pages/landing3/": 8943,
	"./template/pages/landing3/assets/about.jpg": 61140,
	"./template/pages/landing3/assets/blog_thumb1.jpg": 95137,
	"./template/pages/landing3/assets/blog_thumb2.jpg": 19350,
	"./template/pages/landing3/assets/blog_thumb3.jpg": 47763,
	"./template/pages/landing3/assets/brand1.svg": 68657,
	"./template/pages/landing3/assets/brand2.svg": 27906,
	"./template/pages/landing3/assets/brand3.svg": 15283,
	"./template/pages/landing3/assets/brand4.svg": 9068,
	"./template/pages/landing3/assets/brand5.svg": 56429,
	"./template/pages/landing3/assets/hero_image.jpg": 28961,
	"./template/pages/landing3/assets/hero_image.svg": 64731,
	"./template/pages/landing3/assets/info.png": 54219,
	"./template/pages/landing3/assets/project1.png": 61451,
	"./template/pages/landing3/assets/project2.png": 90160,
	"./template/pages/landing3/assets/project3.png": 96409,
	"./template/pages/landing3/assets/service_ico1.svg": 58125,
	"./template/pages/landing3/assets/service_ico2.svg": 29006,
	"./template/pages/landing3/assets/service_ico3.svg": 50111,
	"./template/pages/landing3/assets/service_ico4.svg": 91552,
	"./template/pages/landing3/index": 8943,
	"./template/pages/landing3/index.jsx": 8943,
	"./template/pages/landing3/style.scss": 63502,
	"./template/pages/personalPortfolio": 82301,
	"./template/pages/personalPortfolio/": 82301,
	"./template/pages/personalPortfolio/assets/brand1.svg": 21313,
	"./template/pages/personalPortfolio/assets/brand2.svg": 28178,
	"./template/pages/personalPortfolio/assets/brand3.svg": 42819,
	"./template/pages/personalPortfolio/assets/brand4.svg": 72636,
	"./template/pages/personalPortfolio/assets/brand5.svg": 62109,
	"./template/pages/personalPortfolio/assets/contact_ico1.svg": 30642,
	"./template/pages/personalPortfolio/assets/contact_ico2.svg": 19329,
	"./template/pages/personalPortfolio/assets/hero_image.png": 26483,
	"./template/pages/personalPortfolio/assets/project1.png": 80197,
	"./template/pages/personalPortfolio/assets/project2.png": 61422,
	"./template/pages/personalPortfolio/assets/project3.png": 51415,
	"./template/pages/personalPortfolio/assets/project4.png": 71800,
	"./template/pages/personalPortfolio/assets/project5.png": 44513,
	"./template/pages/personalPortfolio/assets/project6.png": 95530,
	"./template/pages/personalPortfolio/index": 82301,
	"./template/pages/personalPortfolio/index.jsx": 82301,
	"./template/pages/personalPortfolio/style.scss": 84510,
	"./template/pages/pricing": 7935,
	"./template/pages/pricing/": 7935,
	"./template/pages/pricing/assets/brand1.svg": 56719,
	"./template/pages/pricing/assets/brand2.svg": 54396,
	"./template/pages/pricing/assets/brand3.svg": 82941,
	"./template/pages/pricing/assets/brand4.svg": 49010,
	"./template/pages/pricing/assets/brand5.svg": 52323,
	"./template/pages/pricing/index": 7935,
	"./template/pages/pricing/index.jsx": 7935,
	"./template/pages/pricing/style.scss": 83660,
	"./template/pages/projectDetails": 59732,
	"./template/pages/projectDetails/": 59732,
	"./template/pages/projectDetails/assets/case_study_cover.png": 70094,
	"./template/pages/projectDetails/assets/img1.jpg": 97934,
	"./template/pages/projectDetails/index": 59732,
	"./template/pages/projectDetails/index.jsx": 59732,
	"./template/pages/projectDetails/style.scss": 85015,
	"./template/pages/projects": 67721,
	"./template/pages/projects/": 67721,
	"./template/pages/projects/assets/project1.png": 97817,
	"./template/pages/projects/assets/project2.png": 31234,
	"./template/pages/projects/assets/project3.png": 5387,
	"./template/pages/projects/assets/project4.png": 55476,
	"./template/pages/projects/assets/project5.png": 76605,
	"./template/pages/projects/assets/project6.png": 95398,
	"./template/pages/projects/assets/project7.png": 76943,
	"./template/pages/projects/assets/project8.png": 2136,
	"./template/pages/projects/assets/project9.png": 23265,
	"./template/pages/projects/index": 67721,
	"./template/pages/projects/index.jsx": 67721,
	"./template/pages/projects/style.scss": 59200,
	"./template/pages/saasLanding": 25113,
	"./template/pages/saasLanding/": 25113,
	"./template/pages/saasLanding/assets/brand1.svg": 10676,
	"./template/pages/saasLanding/assets/brand2.svg": 82183,
	"./template/pages/saasLanding/assets/brand3.svg": 42646,
	"./template/pages/saasLanding/assets/brand4.svg": 26329,
	"./template/pages/saasLanding/assets/brand5.svg": 44584,
	"./template/pages/saasLanding/assets/feature_ico1.svg": 21753,
	"./template/pages/saasLanding/assets/feature_ico2.svg": 30378,
	"./template/pages/saasLanding/assets/feature_ico3.svg": 90747,
	"./template/pages/saasLanding/assets/hero_image.svg": 77822,
	"./template/pages/saasLanding/assets/review_brand1.svg": 96651,
	"./template/pages/saasLanding/assets/review_brand2.svg": 57816,
	"./template/pages/saasLanding/assets/review_brand3.svg": 92681,
	"./template/pages/saasLanding/assets/review_user1.svg": 69831,
	"./template/pages/saasLanding/assets/review_user2.svg": 5268,
	"./template/pages/saasLanding/assets/review_user3.svg": 43253,
	"./template/pages/saasLanding/assets/showcase1.png": 33914,
	"./template/pages/saasLanding/assets/showcase2.png": 55025,
	"./template/pages/saasLanding/index": 25113,
	"./template/pages/saasLanding/index.jsx": 25113,
	"./template/pages/saasLanding/style.scss": 64189,
	"./template/pages/services": 28567,
	"./template/pages/services/": 28567,
	"./template/pages/services/assets/service_ico1.svg": 761,
	"./template/pages/services/assets/service_ico2.svg": 40010,
	"./template/pages/services/assets/service_ico3.svg": 57851,
	"./template/pages/services/assets/service_ico4.svg": 24788,
	"./template/pages/services/assets/service_ico5.svg": 66773,
	"./template/pages/services/assets/service_ico6.svg": 9174,
	"./template/pages/services/assets/service_ico7.svg": 96295,
	"./template/pages/services/assets/service_ico8.svg": 19728,
	"./template/pages/services/index": 28567,
	"./template/pages/services/index.jsx": 28567,
	"./template/pages/services/style.scss": 78954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;